<div id="mainheader" class="fixed-top custombg " style=" z-index: 100;" *ngIf="!noHeader">
  <!-- <app-header [demoIcon]="demoIconFlag"></app-header> -->
  <div class="my-2">
    <app-categorybar (emitValues)="getFilterValues($event)"></app-categorybar>
  </div>
</div>
<div infinite-scroll (scrolled)="onScroll()" class="profiles-section">
  <div class="container-fluid cards_box " style="padding-left:25px;padding-right:23px">
    <ng-container>
      <ng-container>

        <div class="row  margin-bottom-to-footer">

          <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 p-2 " *ngFor="let employee of searchResults ">

            <div class="card">

              <div *ngIf="!employee.isProjectAllocated" class="available-resource">Available</div>


              <div style="position: absolute;top: 10; z-index:1; width: 100%">
                <div class="d-flex justify-content-end">
                  <div class="mr-2" style="position: relative; width: 20px">
                    <div class="container_chk1">
                    </div>
                  </div>
                </div>
              </div>

              <div class="row m-0 border-bottom">
                <div class="col-8 p-0 locationspace">
                  <div class="img_spacing d-flex certified-section">
                    <div *ngIf="employee.isCertified" class="success">
                      <i class="fas fa-check"></i> Certified
                    </div>
                  </div>
                  <div class="content_spacing" style="height:16px;overflow:hidden"><span
                      class="mx-auto d-block heading_3 text-truncate"
                      matTooltip="{{employee.firstName }} {{ employee.lastName }}"
                      matTooltipPosition="right">{{employee.firstName}} {{ employee.lastName }}</span>
                  </div>
                  <div class="content_spacing d-inline-flex  "><span><i
                        class="fas fa-map-marker-alt mr-2"></i></span><span class="d-block heading_3 text-truncate"
                      style="font-size: 0.750em;font-weight: 400;line-height: 14px;color: #939393; margin-top:6px"
                      matTooltip="{{employee.location}}" matTooltipPosition="right">{{employee.location}}</span>
                  </div>
                  <div class="content_spacing d-flex" *ngIf="showSearchRelevancy && employee.score"><span><i
                        class="fas fa-star mr-2"></i></span><span class="d-block heading_3 text-truncate"
                      style="font-size: 0.750em;font-weight: 400;line-height: 14px;color: #939393; margin-top:6px"
                      matTooltip="Search Relevance Score" matTooltipPosition="left">{{employee.score |
                      number:'1.0-1'}}</span>
                  </div>
                  <div class="content_spacing" *ngIf="true"><span class="secondaryInfo ">Experience: </span><span
                      class="secondaryInfo ">{{employee.experience}} years
                    </span><br>
                    <span class="secondaryInfo">Grade: </span><span class="organizationName">{{ employee.grade }}</span>
                  </div>
                  <div class="content_spacing employee-id"><span style="margin-left:-2px">
                    </span>
                    <div class="secondaryInfo">Employee Id:
                      <span class="organizationName">{{employee.employeeId}}</span>
                    </div>
                  </div>
                </div>

                <div class="col-4" style="position: relative">
                  <img class="mx-auto d-block locationimg" width="100%" height="100%"
                    src="{{employee.profilePicture}}||../../../assets/images/user_avtar.png" />
                  <button mat-button [matMenuTriggerFor]="menu" class="dotted-hamburger">
                    <div></div>
                    <div></div>
                    <div></div>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item><i class="fas fa-envelope py-3 mr-1"></i>Email Resume</button>
                    <button mat-menu-item (click)="downloadResume(employee.employeeId)"><i
                        class="fas fa-download mr-1"></i>Download Resume</button>
                  </mat-menu>
                </div>
              </div>

              <div class="row m-0 ">
                <div class="col-xl-12 col-md-12 p-0  ">
                  <div class="row">

                    <div class="col-6 col-md-6 pl-3">
                      <div class="content_spacing1 mt-1" style="width: 100%">
                        <div><i class="fas fa-briefcase mr-2"></i></div>
                        <div class="secondaryInfo pt-2">Project Name </div>
                      </div>
                      <div class="content_spacing1 w-100 ">
                        <div class="heading_2 pl-3 text-truncate" matTooltip="{{employee.project}}"
                          matTooltipPosition="right">
                          {{employee.project}}</div>
                      </div>
                    </div>

                    <div class="col-6 col-md-6 pl-0">
                      <div class="content_spacing1">
                        <div><i class="far fa-user mr-2 mr-2"></i></div>
                        <div class="secondaryInfo pt-2">Manager </div>
                      </div>
                      <div class="content_spacing1 w-100">
                        <div class="heading_3 pl-3 text-truncate"
                          matTooltip="{{employee.managerFirstName}} {{employee.managerLastName}}"
                          matTooltipPosition="right">
                          {{employee.managerFirstName}} {{employee.managerLastName}}</div>
                      </div>
                    </div>

                    <div class="col-6 col-md-6 pl-3">
                      <div class="content_spacing1 mt-1" style="width: 100%">
                        <div><i class="fas fa-briefcase mr-2"></i></div>
                        <div class="secondaryInfo pt-2">Competency </div>
                      </div>
                      <div class="content_spacing1 w-100 ">
                        <div class="heading_3 pl-3 text-truncate" matTooltipPosition="right"
                          matTooltip="{{employee.competencyName}}">
                          {{employee.competencyName}}
                        </div>
                      </div>
                    </div>


                    <div class="col-6 col-md-6 col-lg-6 pl-0" *ngIf="employee.isSME">
                      <div class="content_spacing1 ">
                        <div><i class="far fa-user mr-2 mr-2"></i></div>
                        <div class="secondaryInfo pt-2">SME-Tech</div>
                      </div>
                      <div class="content_spacing1 w-100 ">

                        <div class="heading_3 pl-3 text-truncate" *ngFor="let sme of employee.smEs"
                          matTooltipPosition="right" matTooltip="{{sme.technologies}}">
                          {{sme.technologies}}
                        </div>

                      </div>
                    </div>

                    <div class="col-12 tags">
                      <div class="content_spacing1 mt-2  border-top" style="width: 100%">
                        <div class="mt-2"><i class="fas fa-tag mr-2  "></i></div>
                        <div class="secondaryInfo pt-2 mt-2  ">Skills</div>
                      </div>
                      <div class="content_spacing1 chide ">
                        <div class="bodyCopy pl-3 " style="word-break: break-word">{{employee.tagCloud}}</div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
<div *ngIf="noDataFound" class="noData">
  <h4>No Records Found.</h4>
</div>